const CONSENT_KEY = 'cookie-consent'

export function useCookieConsent() {
  const accepted = useState<boolean | null>('cookieConsent', () => null)

  onMounted(() => {
    accepted.value = localStorage.getItem(CONSENT_KEY) === 'accepted'
  })

  function accept() {
    localStorage.setItem(CONSENT_KEY, 'accepted')
    accepted.value = true
  }

  function decline() {
    localStorage.setItem(CONSENT_KEY, 'declined')
    accepted.value = false
  }

  const showBanner = computed(() => accepted.value === false || accepted.value === null && import.meta.client)

  return { accepted, showBanner, accept, decline }
}
